import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { getObjFromId } from '../../../utils/directusFunctions';
import { hasRole } from '../../../utils/userRoles';
import SingleSelect from '../../formElements/SingleSelect';

import form from '../../../commonStyles/formStyles.module.css';
import local from './configureServiceStyles.module.css';

const OnDemandAppointmentReminders = ({ acceptedRoles, onUpdateConstants, constants }) => {
    // LOCAL STATE
    const [letterTemplates, setLetterTemplates] = useState([]);
    const [emailTemplates, setEmailTemplates] = useState([]);

    // STORE STATE
    const roles = useSelector((state) => state.entities.userService.loggedInUser.roles);
    const communicationTypes = useSelector(
        (state) => state.entities.directusService.communicationTypes
    );
    const communicationTemplates = useSelector(
        (state) => state.entities.communicationService.communicationTemplates
    );

    // USEEFFECTS

    useEffect(() => {
        if (communicationTypes?.length < 1 || communicationTemplates?.length < 1) return;
        setLetterTemplates(
            communicationTemplates.filter(
                (el) =>
                    el.typeId === communicationTypes.find((entry) => entry.name === 'Letter')?.id
            )
        );
        setEmailTemplates(
            communicationTemplates.filter(
                (el) => el.typeId === communicationTypes.find((entry) => entry.name === 'Email')?.id
            )
        );
    }, [communicationTemplates, communicationTypes]);

    return (
        <div className={local.onDemandTemplatesSection}>
            <h3>On Demand Appointment Reminders</h3>
            <div className={form.formWrapper}>
                <div className={form.formSection}>
                    <div className={form.formColumn}>
                        <SingleSelect
                            id="notKnownEmailTemplateId"
                            label="Not Known Email Template"
                            placeholder="Select not known email template..."
                            disabled={!hasRole(acceptedRoles, roles)}
                            capitalizeList={false}
                            menuItems={emailTemplates || []}
                            selectedId={constants.notKnownEmailTemplateId || ''}
                            selected={getObjFromId(
                                emailTemplates,
                                constants.notKnownEmailTemplateId
                            )}
                            onChange={(id) => onUpdateConstants('notKnownEmailTemplateId', id)}
                        />
                        <SingleSelect
                            id="ftaEmailTemplateId"
                            label="FTA Email Template"
                            placeholder="Select FTA email template..."
                            disabled={!hasRole(acceptedRoles, roles)}
                            capitalizeList={false}
                            menuItems={emailTemplates || []}
                            selectedId={constants.ftaEmailTemplateId || ''}
                            selected={getObjFromId(emailTemplates, constants.ftaEmailTemplateId)}
                            onChange={(id) => onUpdateConstants('ftaEmailTemplateId', id)}
                        />
                    </div>
                    <div className={form.formColumn}>
                        <SingleSelect
                            id="notKnownLetterTemplateId"
                            label="Not Known Letter Template"
                            placeholder="Select not known letter template..."
                            disabled={!hasRole(acceptedRoles, roles)}
                            capitalizeList={false}
                            menuItems={letterTemplates || []}
                            selectedId={constants.notKnownLetterTemplateId || ''}
                            selected={getObjFromId(
                                letterTemplates,
                                constants.notKnownLetterTemplateId
                            )}
                            onChange={(id) => onUpdateConstants('notKnownLetterTemplateId', id)}
                        />
                        <SingleSelect
                            id="ftaLetterTemplateId"
                            label="FTA Letter Template"
                            placeholder="Select FTA letter template..."
                            disabled={!hasRole(acceptedRoles, roles)}
                            capitalizeList={false}
                            menuItems={letterTemplates || []}
                            selectedId={constants.ftaLetterTemplateId || ''}
                            selected={getObjFromId(letterTemplates, constants.ftaLetterTemplateId)}
                            onChange={(id) => onUpdateConstants('ftaLetterTemplateId', id)}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

OnDemandAppointmentReminders.propTypes = {
    acceptedRoles: PropTypes.arrayOf(PropTypes.string),
    onUpdateConstants: PropTypes.func,
    constants: PropTypes.object
};

export default OnDemandAppointmentReminders;
